import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { errorMsg } from 'utils';
import { url } from 'utils/url';

export const NOTIFICATIONS_FETCH_DATA_INIT = createAction(
  'NOTIFICATIONS_FETCH_DATA_INIT'
);
export const NOTIFICATIONS_FETCH_DATA_SUCCESS = createAction(
  'NOTIFICATIONS_FETCH_DATA_SUCCESS'
);
export const NOTIFICATIONS_FETCH_DATA_FAIL = createAction(
  'NOTIFICATIONS_FETCH_DATA_FAIL'
);
export const NOTIFICATIONS_UPDATE_DATA_INIT = createAction(
  'NOTIFICATIONS_UPDATE_DATA_INIT'
);
export const NOTIFICATIONS_UPDATE_DATA_SUCCESS = createAction(
  'NOTIFICATIONS_UPDATE_DATA_SUCCESS'
);
export const NOTIFICATIONS_UPDATE_DATA_FAIL = createAction(
  'NOTIFICATIONS_UPDATE_DATA_FAIL'
);

export const NOTIFICATIONS_CLEAN_UP = createAction('NOTIFICATIONS_CLEAN_UP');

export const fetchNotifications = (status = null) => {
  return async (dispatch) => {
    dispatch(NOTIFICATIONS_FETCH_DATA_INIT());
    let listNotifications = [];

    try {
      const res = await axios.get(`${url}/site/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      const siteList = res.data.data;

      // Use the new unified approval endpoint
      const approvalDataList = await Promise.all(
        siteList.map(async (site) => {
          try {
            const payload = {
              siteId: site._id,
              categoryId: 'all',
            };

            // Add status filter if specified
            if (status && status !== 'all') {
              payload.status = status;
            }

            const approvalRes = await axios.post(
              `${url}/approval/filter`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    'accessToken'
                  )}`,
                },
              }
            );

            const { media, poi, information } = approvalRes.data.data;

            // Map each type with appropriate page label
            const mediaWithPage = media.map((m) => ({
              ...m,
              page: 'Media',
              siteId: site._id,
            }));

            const poiWithPage = poi.map((p) => ({
              ...p,
              page: 'Tenant',
              siteId: site._id,
            }));

            const informationWithPage = information.map((i) => ({
              ...i,
              page: 'Information',
              siteId: site._id,
            }));

            return [...mediaWithPage, ...poiWithPage, ...informationWithPage];
          } catch (err) {
            console.error('Approval data failed for site', site._id, err);
            return [];
          }
        })
      );

      const getApprovalStatus = (item) => {
        if (
          item.approval === 'pending' ||
          item.status === 'waiting for approval'
        )
          return 'pending';
        if (item.approval === '' || item.approval === 'approved')
          return 'approved';
        if (item.approval === false || item.approval === 'declined')
          return 'declined';
        return 'unknown';
      };

      listNotifications = approvalDataList
        .flat()
        ?.filter(
          (item) => item.approval !== undefined && item.approval !== null
        )
        .filter((item) => {
          const status = getApprovalStatus(item);
          if (status === 'pending') return true;

          const now = Date.now();
          const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
          const date = new Date(item.modifiedAt);
          return now - date.getTime() <= THIRTY_DAYS;
        })
        .sort((a, b) => {
          const dateA = new Date(a.modifiedAt || 0);
          const dateB = new Date(b.modifiedAt || 0);
          return dateB - dateA;
        });

      console.log('Notifications list:', listNotifications);
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(NOTIFICATIONS_FETCH_DATA_FAIL({ error }));
    }

    dispatch(
      NOTIFICATIONS_FETCH_DATA_SUCCESS({
        list: listNotifications,
      })
    );
  };
};

export const notificationsCleanUp = () => (dispatch) =>
  dispatch(NOTIFICATIONS_CLEAN_UP());
